import { gql } from '@apollo/client';

export const PageSEOFragment = gql`
  fragment PageSEOFragment on Page {
    seo {
      title
      description
      canonicalUrl
      fullHead
      focusKeywords
      robots
      openGraph {
        title
        description
        image {
          secureUrl
          url
        }
      }
    }
  }
`; 